export default "__VITE_PUBLIC_ASSET__1b79ffde__"